import RadioGroupAPI from './radio-group-api';

export default RadioGroupAPI;
